import { render } from "./QuestionnaireView.vue?vue&type=template&id=5b95b898&scoped=true&ts=true"
import script from "./QuestionnaireView.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireView.vue?vue&type=script&lang=ts"

import "./QuestionnaireView.vue?vue&type=style&index=0&id=5b95b898&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b95b898"]])

export default __exports__